import React from "react";
// import Card from "./Card";
// import Pokeinfo from "./Pokeinfo";
import "../components/style.css";

const Teams = () => {
  return (
    <>
    <div className="landingPageContainer">
        <div className="welcomeText">
            <h2>
               TEAMS PAGE (not Coded)
            </h2>
        </div>
        </div>
    </>
  );
};

export default Teams;
